import {utils} from '@wallaby-ui/core';
import {forOwn, isEmpty} from 'lodash';

const DOCUMENT_TITLE_MAX_LENGTH = 100;
const DOCUMENT_TEXT_MAX_LENGTH = 300;

const DOCUMENT_ID = 'id';
const DOCUMENT_SCORE = 'score';
const DOCUMENT_TITLE = 'title';
const DOCUMENT_TEXT = 'text';
const DOCUMENT_METADATA = 'metadata';
const DOCUMENT_METADATA_MAP = 'metadataMap';

const DOCUMENT_HIGHLIGHT_FIELD = 'field';
const DOCUMENT_HIGHLIGHT_FIELD_NAME = 'name';
const DOCUMENT_HIGHLIGHT_SNIPPETS = 'snipplets';

export class Document {
  static initHighlighting(rawData) {
    const highlighting = {};
    if (rawData && rawData[0]) {
      forOwn(rawData, (item) => {
        if (item[DOCUMENT_HIGHLIGHT_FIELD]) {
          highlighting[
            item[DOCUMENT_HIGHLIGHT_FIELD][DOCUMENT_HIGHLIGHT_FIELD_NAME]
          ] = item[DOCUMENT_HIGHLIGHT_SNIPPETS];
        }
      });
    }
    return highlighting;
  }

  static getPropertyLabel(propertyName, labels) {
    return labels && labels[propertyName] ? labels[propertyName] : propertyName;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  getId() {
    return this.rawData[DOCUMENT_ID];
  }

  getTitle(highlighted = false, trim = false) {
    let resultSnippets = [];
    if (
      highlighted &&
      this.rawDataHighlighting &&
      this.getHighlighting()[DOCUMENT_TITLE]
    ) {
      resultSnippets = this.getHighlighting()[DOCUMENT_TITLE];
    } else {
      const snippet = trim
        ? utils.StringUtils.trimWithoutCuttingWord(
            this.rawData[DOCUMENT_TITLE],
            DOCUMENT_TITLE_MAX_LENGTH
          )
        : this.rawData[DOCUMENT_TITLE];
      if (!isEmpty(snippet)) {
        resultSnippets.push(snippet);
      }
    }
    return resultSnippets;
  }

  getText(highlighted = false, trim = false) {
    let resultSnippets = [];
    if (
      highlighted &&
      this.rawDataHighlighting &&
      this.getHighlighting()[DOCUMENT_TEXT]
    ) {
      resultSnippets = this.getHighlighting()[DOCUMENT_TEXT];
    } else {
      const snippet = trim
        ? utils.StringUtils.trimWithoutCuttingWord(
            this.rawData[DOCUMENT_TEXT],
            DOCUMENT_TEXT_MAX_LENGTH
          )
        : this.rawData[DOCUMENT_TEXT];
      if (!isEmpty(snippet)) {
        resultSnippets.push(snippet);
      }
    }
    return resultSnippets;
  }

  getScore() {
    return this.rawData[DOCUMENT_SCORE];
  }

  getSize() {
    return this.rawData[DOCUMENT_TEXT] ? this.rawData[DOCUMENT_TEXT].length : 0;
  }

  getProperty(propertyName) {
    return this.rawData[propertyName];
  }

  getMetadataMap() {
    return this.rawData[DOCUMENT_METADATA] &&
      this.rawData[DOCUMENT_METADATA][DOCUMENT_METADATA_MAP]
      ? this.rawData[DOCUMENT_METADATA][DOCUMENT_METADATA_MAP]
      : {};
  }

  getMetadataProperty(propertyName) {
    return this.getMetadataMap()[propertyName];
  }

  getHighlighting() {
    return this.highlighting;
  }

  setHighlighting(highlighting) {
    this.rawDataHighlighting = [...highlighting];
    this.highlighting = Document.initHighlighting(this.rawDataHighlighting);
  }
}

export default {Document};
